/**
 * Grid size utilities for dashboard layout
 * Handles 12-column grid system with responsive behavior
 */

export type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

// Available grid sizes for resize snapping (1-12)
export const GRID_SIZES: GridSize[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

/**
 * Get Tailwind CSS class for grid column span
 * For sizes 1-5: mobile full width, desktop actual size
 * For sizes 6-12: responsive behavior
 */
export function getGridSizeClass(size: GridSize): string {
    const classes: Record<GridSize, string> = {
        1: 'col-span-12 md:col-span-1',
        2: 'col-span-12 md:col-span-2',
        3: 'col-span-12 md:col-span-3',
        4: 'col-span-12 md:col-span-4',
        5: 'col-span-12 md:col-span-5',
        6: 'col-span-12 md:col-span-6',
        7: 'col-span-12 md:col-span-7',
        8: 'col-span-12 md:col-span-8',
        9: 'col-span-12 md:col-span-9',
        10: 'col-span-12 md:col-span-10',
        11: 'col-span-12 md:col-span-11',
        12: 'col-span-12',
    }
    return classes[size] || 'col-span-12 md:col-span-6'
}

/**
 * Calculate column span from pixel width change
 * Snaps to nearest valid grid size (1-12)
 */
export function calculateColSpan(
    deltaX: number,
    startWidth: number,
    containerWidth: number,
    currentColSpan: GridSize
): GridSize {
    const colWidth = containerWidth / 12
    const newWidth = startWidth + deltaX
    const newCols = Math.round(newWidth / colWidth)

    // Find closest valid grid size
    let closest: GridSize = currentColSpan
    let minDiff = Infinity

    for (const size of GRID_SIZES) {
        const diff = Math.abs(size - newCols)
        if (diff < minDiff) {
            minDiff = diff
            closest = size
        }
    }

    return closest
}
